import { TenantAppearanceToggle } from './TenantAppearanceToggle';

/** Fixed bottom-left appearance on desktop when the sidebar is unavailable (login, loading). Hidden on mobile — use the menu drawer instead. */
export function TenantAppearanceDock() {
  return (
    <div className="fixed bottom-[max(1rem,env(safe-area-inset-bottom))] left-[max(1rem,env(safe-area-inset-left))] z-50 hidden rounded-lg border border-gray-200 bg-white shadow-bento dark:border-white/10 dark:bg-gray-900 xl:block">
      <TenantAppearanceToggle variant="compact" />
    </div>
  );
}
